import { useNavigate } from "react-router-dom";
import { useAccount } from "../account/context";
import { MegaMenu } from "../shared/mega-menu";
import { useClinicalAccount } from "../account/clinical-context";

export interface INavItem {
  text: string;
  path: string;
}

export const Header = () => {
  const { isLoggedIn, doLogout } = useAccount();
  const { isClinician, doClinicianLogout } = useClinicalAccount();

  const navigate = useNavigate();

  return (
    <header>
      <div className="constrained">
        <a
          href="/"
          className="logo"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <h1>Kidney failure</h1>
          <p>Making a plan that works for you</p>
        </a>
        <nav>
          <ul>
            <li>
              <a
                className={
                  document.location.pathname === "/" ? "selected" : ""
                }
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/");
                }}
                href="/"
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#"
                className={
                  document.location.pathname.indexOf("/treatment-options/") > -1
                    ? "selected"
                    : ""
                }
              >
                Treatment Options
              </a>
              <MegaMenu />
            </li>
            <li>
              <a
                className={
                  document.location.pathname === "/planning" ? "selected" : ""
                }
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/planning");
                }}
                href="planning"
              >
                Planning
              </a>
            </li>
            <li>
              <a
                className={
                  document.location.pathname === "/compare" ? "selected" : ""
                }
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/compare");
                }}
                href="/compare"
              >
                Compare
              </a>
            </li>
            <li className="favourites">
              <a
                href="/favourites"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/account/favourites");
                }}
              >
                Favourites
              </a>
            </li>
            <li className="account">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/account/profile");
                }}
                href="/account/profile"
              >
                Account
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

const SubmenuStyles = {
  background: "#fff",
  padding: "16px 24px",
};
// <Navigation />
